
import React, { useEffect, useState } from 'react'
import BossDialog from '../../components/BossDialog';
import { EditPageHeader } from '../../components/EditPageHeader';
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import { ENTITYNAME, LOGEVENT, MODULE, SLOT_TYPE, TOAST_TYPES, HEADERTYPE, HeaderType, PROGRAMSCHEDULESLOTTYPE } from '../../framework/constant/constant';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import ToastNotification from '../../components/ToastNotification';
import * as API from "../../framework/API/api";
import moment from 'moment';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import { TimePickerWithFormat } from '../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';
import SlotEditForm from '../masters/SlotEditForm';

const ProgramScheduleSlotEditForm = (props) => {
    const lang = useTranslation();

    const slotObj = props?.item?.Slot ?? {};
    const blankDataItem = {
        ...props?.item,
        SID: props?.item?.SID ?? 0,
        Channel: props?.item?.Channel ?? {},
        Slot: slotObj,
        Title: props?.item?.Title || slotObj?.Title || "",
        CustomTitle: props?.item?.CustomTitle || slotObj?.CustomTitle || "",
        Description: props?.item?.Description || slotObj?.Description || "",
        CustomDescription: props?.item?.CustomDescription || slotObj?.CustomDescription || "",
        Code: props?.item?.Code || slotObj?.Code || "",
        Duration: props?.item?.Duration
            ? (typeof props.item.Duration === 'number' ? utility.convertMilisecondsToStringWithFrames(props.item.Duration) : props.item.Duration)
            : (slotObj?.Duration ? (typeof slotObj.Duration === 'number' ? utility.convertMilisecondsToStringWithFrames(slotObj.Duration) : slotObj.Duration) : "00:00:00:00"),
        Genre: (props?.item?.Genre && Object.keys(props.item.Genre).length > 0) ? props.item.Genre : (slotObj?.Genre ?? {}),
        ProductionYear: props?.item?.ProductionYear || slotObj?.ProductionYear || "",
        PGRating: (props?.item?.PGRating && Object.keys(props.item.PGRating).length > 0) ? props.item.PGRating : (slotObj?.PGRating ?? {}),
        TargetAudience: (props?.item?.TargetAudience && Object.keys(props.item.TargetAudience).length > 0) ? props.item.TargetAudience : (slotObj?.TargetAudience ?? {}),
        ProductionType: (props?.item?.ProductionType && Object.keys(props.item.ProductionType).length > 0) ? props.item.ProductionType : (slotObj?.ProductionType ?? {}),
        SlotType: (props?.item?.SlotType && Object.keys(props.item.SlotType).length > 0) ? props.item.SlotType : (slotObj?.SlotType ?? {}),
        ProgramScheduleSlotType: props?.item?.ProgramScheduleSlotType ?? 1,
        BgColor: props?.item?.BgColor || slotObj?.BgColor || "#4559bf",
        Breaks: props?.item?.Breaks ?? slotObj?.Breaks ?? 0,
        SlotDateTime: (props?.item?.SlotDateTime || props?.item?.SlotStart)
            ? moment.utc(props?.item?.SlotDateTime || props?.item?.SlotStart).format('YYYY-MM-DDTHH:mm')
            : moment.utc().format('YYYY-MM-DDTHH:mm'),
        Remarks: props?.item?.Remarks ?? "",
        Archive: props?.item?.Archive ?? false
    };

    const programScheduleSlotTypeOptions = [
        { text: "Primary", value: PROGRAMSCHEDULESLOTTYPE?.Primary ?? 1 },
        { text: "Repeat", value: PROGRAMSCHEDULESLOTTYPE?.Repeat ?? 2 }
    ];

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [channel, setChannel] = useState([]);
    const [genres, setGenres] = useState([]);
    const [targetAudiences, setTargetAudiences] = useState([]);
    const [productionTypes, setProductionTypes] = useState([]);
    const [pGRatings, setPGRatings] = useState([]);
    const [slotTypes, setSlotTypes] = useState([]);
    const [openSlotSelection, setOpenSlotSelection] = useState(false);
    const [showCreateSlot, setShowCreateSlot] = useState(false);

    const onChange = (e) => {
        if (e.target.name === "Archive") {
            setDataItem((prev) => ({ ...prev, Archive: !prev.Archive }));
        }
        else {
            setDataItem((prev) => ({ ...prev, [e.target.name]: e.target.value }));
        }
    };

    useEffect(() => {
        loadCombo();
    }, [])

    const loadCombo = async () => {
        const channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        const channelsList = channelRes?.data || [];
        setChannel(channelsList);

        // If dataItem already has Channel with SID or _id, ensure full channel object from lookup list is selected
        if (blankDataItem?.Channel && channelsList.length > 0) {
            const matched = channelsList.find((c) =>
                (blankDataItem.Channel._id && c._id === blankDataItem.Channel._id) ||
                (blankDataItem.Channel.SID != null && c.SID === blankDataItem.Channel.SID)
            );
            if (matched) {
                setDataItem((prev) => ({ ...prev, Channel: matched }));
            }
        }

        const genreRes = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
        setGenres(genreRes.data);
        const targetAudienceRes = await API.getDataLookup(ENTITYNAME.Audience, { sort: { Description: 1 } });
        setTargetAudiences(targetAudienceRes.data);
        const productionTypeRes = await API.getDataLookup(ENTITYNAME.ProductionType, { sort: { Description: 1 } });
        setProductionTypes(productionTypeRes.data);
        const pGRatingRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
        setPGRatings(pGRatingRes.data);
        const slotTypeRes = Object.keys(SLOT_TYPE).map((x) => {
            return {
                _id: SLOT_TYPE[x],
                Description: x
            }
        });
        setSlotTypes(slotTypeRes);
    }

    const isValid = () => {
        if (dataItem.Channel == undefined || Object.keys(dataItem.Channel).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }
        if (dataItem.Slot == undefined || Object.keys(dataItem.Slot).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_slot_error_message ?? "Please select Slot" });
            return false;
        }
        return true;
    };

    const handleSubmit = async () => {
        if (isValid()) {
            const slotDurationVal = dataItem?.Duration ? utility.convertStringWithFramesToMilliseconds(dataItem?.Duration) : (dataItem?.Slot?.Duration || 0);
            const slotDateTimeVal = dataItem.SlotDateTime ? moment.utc(dataItem.SlotDateTime).valueOf() : null;
            const saveData = {
                _id: dataItem._id,
                SID: dataItem.SID,
                Title: dataItem?.Title,
                Description: dataItem?.Description || dataItem?.Title,
                Duration: slotDurationVal,
                SlotStart: slotDateTimeVal,
                SlotEnd: slotDateTimeVal != null ? (slotDateTimeVal + slotDurationVal) : null,
                BgColor: dataItem?.BgColor || "#4559bf",
                Channel: dataItem?.Channel && Object.keys(dataItem.Channel).length > 0 ? {
                    _id: dataItem?.Channel?._id,
                    SID: dataItem?.Channel?.SID,
                    FullChannelName: dataItem?.Channel?.FullChannelName
                } : {},
                Slot: dataItem?.Slot && Object.keys(dataItem?.Slot).length > 0 ? {
                    _id: dataItem?.Slot?._id,
                    SID: dataItem?.Slot?.SID,
                    Title: dataItem?.Title,
                    CustomTitle: dataItem?.CustomTitle,
                    Description: dataItem?.Description,
                    CustomDescription: dataItem?.CustomDescription,
                    Code: dataItem?.Code,
                    Duration: slotDurationVal,
                    Genre: dataItem?.Genre && Object.keys(dataItem?.Genre).length > 0 ? {
                        _id: dataItem?.Genre?._id,
                        SID: dataItem?.Genre?.SID,
                        Description: dataItem?.Genre?.Description
                    } : {},
                    ProductionYear: dataItem?.ProductionYear,
                    PGRating: dataItem?.PGRating && Object.keys(dataItem?.PGRating).length > 0 ? {
                        _id: dataItem?.PGRating?._id,
                        Description: dataItem?.PGRating?.Description
                    } : {},
                    TargetAudience: dataItem?.TargetAudience && Object.keys(dataItem?.TargetAudience).length > 0 ? {
                        _id: dataItem?.TargetAudience?._id,
                        Description: dataItem?.TargetAudience?.Description
                    } : {},
                    ProductionType: dataItem?.ProductionType && Object.keys(dataItem?.ProductionType).length > 0 ? {
                        _id: dataItem?.ProductionType?._id,
                        Description: dataItem?.ProductionType?.Description
                    } : {},
                    SlotType: dataItem?.SlotType && Object.keys(dataItem?.SlotType).length > 0 ? {
                        _id: dataItem?.SlotType?._id,
                        Description: dataItem?.SlotType?.Description
                    } : {},
                    BgColor: dataItem?.BgColor || "#4559bf",
                    Breaks: dataItem?.Breaks ?? 0,
                } : {},
                SlotDateTime: slotDateTimeVal,
                HeaderType: HEADERTYPE.ProgramScheduleSlot,
                ProgramScheduleSlotType: dataItem?.ProgramScheduleSlotType ?? 1,
                Remarks: dataItem?.Remarks ?? "",
                Archive: dataItem.Archive ?? false
            };
            console.log(saveData);
            let res = await API.saveProgramScheduleSlot(saveData);
            if (res.success) {
                let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.PROGRAM_SCHEDULE_SLOT, data: res.data, message: res.message };
                API.SaveLogs(logData);
                utility.deleteLocalStorageItem(ENTITYNAME.ProgramScheduleSlot);
                if (props.cancelEdit) props.cancelEdit(true);
                else if (props.onClose) props.onClose(true);
                if (props.refresh) props.refresh();
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
        }
    };

    const onSlotSelected = (dataList) => {
        if (dataList && dataList.length > 0) {
            const selectedSlot = dataList[0];
            setDataItem((prev) => ({
                ...prev,
                Slot: selectedSlot,
                Title: selectedSlot?.Title ?? "",
                CustomTitle: selectedSlot?.CustomTitle ?? "",
                Description: selectedSlot?.Description ?? "",
                CustomDescription: selectedSlot?.CustomDescription ?? "",
                Code: selectedSlot?.Code ?? "",
                Duration: selectedSlot?.Duration ? utility.convertMilisecondsToStringWithFrames(selectedSlot?.Duration) : "00:00:00:00",
                Genre: selectedSlot?.Genre ?? {},
                ProductionYear: selectedSlot?.ProductionYear ?? "",
                PGRating: selectedSlot?.PGRating ?? {},
                TargetAudience: selectedSlot?.TargetAudience ?? {},
                ProductionType: selectedSlot?.ProductionType ?? {},
                SlotType: selectedSlot?.SlotType ?? {},
                BgColor: selectedSlot?.BgColor || prev.BgColor || "#4559bf",
                Breaks: selectedSlot?.Breaks ?? 0,
            }));
        }
        setOpenSlotSelection(false);
    };

    const handleClose = () => {
        if (props.cancelEdit) props.cancelEdit(false);
        else if (props.onClose) props.onClose(false);
    };

    const onChangeSlot = (e) => {
        setDataItem((prev) => ({ ...prev, Slot: {}, Title: "", CustomTitle: "", Description: "", CustomDescription: "", Code: "", Duration: "00:00:00:00", Genre: {}, ProductionYear: "", PGRating: {}, TargetAudience: {}, ProductionType: {}, SlotType: {}, BgColor: "#4559bf", Breaks: 0 }));
    }

    return (
        <>
            <BossDialog
                title={props.item.SID > 0 ? props.item.Description : lang.program_schedule_slot_dialog_header}
                onClose={handleClose}
                width={"820px"}
            >
                <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={handleClose} showTitle={false} />
                <div className="mt-2">
                    {/* Row 1: Slot taking full row at first position */}
                    <div className="row g-2 mb-2">
                        <div className="col-12">
                            <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.slot_label} *</label>
                            <div style={{ display: "flex" }}>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={dataItem.Slot?.Title ?? ""}
                                    onChange={() => ""}
                                    disabled={true}
                                    placeholder="Select Slot..."
                                />
                                <ActionButton
                                    style={{ marginLeft: "5px", height: "30px" }}
                                    btnColor={"success"}
                                    title={lang.select_button_tooltip}
                                    name={"..."}
                                    onClick={() => setOpenSlotSelection(true)}
                                />
                                <ActionButton
                                    style={{ marginLeft: "2px", height: "30px" }}
                                    btnColor={"danger"}
                                    title={lang.clear_button_tooltip}
                                    name={""}
                                    icon={"xmark"}
                                    onClick={onChangeSlot}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Row 2: Channel, Slot Date Time */}
                    <div className="row g-2 mb-2">
                        <div className="col-6">
                            <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.channel_label} *</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={channel}
                                name="Channel"
                                textField="FullChannelName"
                                dataItemKey="_id"
                                value={dataItem.Channel}
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-6">
                            <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.slot_date_time_label}</label>
                            <input
                                type="datetime-local"
                                name="SlotDateTime"
                                onChange={onChange}
                                value={dataItem.SlotDateTime}
                                className="form-control form-control-sm"
                            />
                        </div>
                    </div>

                    {/* Row 3: Duration, Schedule Type */}
                    <div className="row g-2 mb-3" style={{ paddingBottom: "4px" }}>
                        <div className="col-6">
                            <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.duration_label}</label>
                            <TimePickerWithFormat
                                className="form-control form-control-sm"
                                name="Duration"
                                value={dataItem.Duration}
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-6">
                            <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.schedule_type_label || "Schedule Type"}</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={programScheduleSlotTypeOptions}
                                textField="text"
                                dataItemKey="value"
                                value={programScheduleSlotTypeOptions.find((o) => o.value === dataItem.ProgramScheduleSlotType) || programScheduleSlotTypeOptions[0]}
                                onChange={(e) => setDataItem((prev) => ({ ...prev, ProgramScheduleSlotType: e.target.value?.value ?? e.target.value }))}
                            />
                        </div>
                    </div>

                    {/* Group Box 1: Basic Details */}
                    <div className="mb-3">
                        <fieldset className="border rounded" style={{ borderColor: "#dee2e6", padding: "6px 12px 10px 12px" }}>
                            <legend className="float-none w-auto text-muted small px-1 mb-1" style={{ fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                                Basic Details
                            </legend>
                            <div className="row g-2">
                                <div className="col-4 mb-2">
                                    <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.title_label}</label>
                                    <input type="text" className="form-control form-control-sm" name="Title" value={dataItem.Title} onChange={onChange} />
                                </div>
                                <div className="col-4 mb-2">
                                    <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.custom_title}</label>
                                    <input type="text" className="form-control form-control-sm" name="CustomTitle" value={dataItem.CustomTitle} onChange={onChange} />
                                </div>
                                <div className="col-4 mb-2">
                                    <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.code_label}</label>
                                    <input type="text" className="form-control form-control-sm" name="Code" value={dataItem.Code} onChange={onChange} />
                                </div>
                                <div className="col-6">
                                    <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.description_label}</label>
                                    <input type="text" className="form-control form-control-sm" name="Description" value={dataItem.Description} onChange={onChange} />
                                </div>
                                <div className="col-6">
                                    <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.custom_description_label}</label>
                                    <input type="text" className="form-control form-control-sm" name="CustomDescription" value={dataItem.CustomDescription} onChange={onChange} />
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    {/* Group Box 2: Metadata */}
                    <div className="mb-3">
                        <fieldset className="border rounded" style={{ borderColor: "#dee2e6", padding: "6px 12px 10px 12px" }}>
                            <legend className="float-none w-auto text-muted small px-1 mb-1" style={{ fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                                Metadata
                            </legend>
                            <div className="row g-2">
                                <div className="col-4 mb-2">
                                    <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.genre_label}</label>
                                    <DropDownList
                                        style={{ backgroundColor: "white" }}
                                        data={genres}
                                        name="Genre"
                                        textField="Description"
                                        dataItemKey="_id"
                                        value={dataItem.Genre}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="col-4 mb-2">
                                    <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.pg_rating_label}</label>
                                    <DropDownList
                                        style={{ backgroundColor: "white" }}
                                        data={pGRatings}
                                        name="PGRating"
                                        textField="Description"
                                        dataItemKey="_id"
                                        value={dataItem.PGRating}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="col-4 mb-2">
                                    <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.production_year_label}</label>
                                    <input type="text" className="form-control form-control-sm" name="ProductionYear" value={dataItem.ProductionYear} onChange={onChange} />
                                </div>
                                <div className="col-4">
                                    <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.target_audience_label}</label>
                                    <DropDownList
                                        style={{ backgroundColor: "white" }}
                                        data={targetAudiences}
                                        name="TargetAudience"
                                        textField="Description"
                                        dataItemKey="_id"
                                        value={dataItem.TargetAudience}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="col-4">
                                    <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.production_type_label}</label>
                                    <DropDownList
                                        style={{ backgroundColor: "white" }}
                                        data={productionTypes}
                                        name="ProductionType"
                                        textField="Description"
                                        dataItemKey="_id"
                                        value={dataItem.ProductionType}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="col-4">
                                    <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.slot_type_label}</label>
                                    <DropDownList
                                        style={{ backgroundColor: "white" }}
                                        data={slotTypes}
                                        name="SlotType"
                                        textField="Description"
                                        dataItemKey="_id"
                                        value={dataItem.SlotType}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    {/* Group Box 3: Settings & Remarks */}
                    <div className="mb-2">
                        <fieldset className="border rounded" style={{ borderColor: "#dee2e6", padding: "6px 12px 10px 12px" }}>
                            <legend className="float-none w-auto text-muted small px-1 mb-1" style={{ fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                                Settings & Remarks
                            </legend>
                            <div className="row g-2 align-items-center">
                                <div className="col-2">
                                    <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>{lang.background_color_label}</label>
                                    <input
                                        type="color"
                                        name="BgColor"
                                        style={{ width: "45px", height: "28px", padding: "2px", cursor: "pointer" }}
                                        onChange={onChange}
                                        value={dataItem.BgColor || "#4559bf"}
                                        className="form-control form-control-sm"
                                    />
                                </div>
                                <div className="col-2">
                                    <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.breaks_label}</label>
                                    <input type="number" className="form-control form-control-sm" name="Breaks" value={dataItem.Breaks} onChange={onChange} />
                                </div>
                                <div className="col-2" style={{ paddingTop: "14px" }}>
                                    <label style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", fontSize: "12px", marginBottom: 0 }}>
                                        <input
                                            style={{ border: "1px solid grey", width: "15px", height: "15px", marginRight: "6px" }}
                                            name={"Archive"}
                                            type="checkbox"
                                            onChange={onChange}
                                            checked={dataItem.Archive}
                                        />
                                        {lang.archive}
                                    </label>
                                </div>
                                <div className="col-6">
                                    <label style={{ fontSize: "12px", marginBottom: "4px" }}>{lang.remark_label}</label>
                                    <textarea rows={1} className="form-control form-control-sm" name="Remarks" value={dataItem.Remarks} onChange={onChange} style={{ resize: "vertical" }} />
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </BossDialog>
            {openSlotSelection && (
                <CollectionSelection
                    showCreate={true}
                    onCreateNew={() => setShowCreateSlot(true)}
                    path={`/home/slot`}
                    addButtonTitle={lang.select_button_text}
                    title={lang.slot_dialog_header}
                    entityname={ENTITYNAME.Slot}
                    closeForm={() => setOpenSlotSelection(false)}
                    setDataList={onSlotSelected}
                    mode={"single"}
                    width={"50vw"}
                />
            )}
            {showCreateSlot && (
                <SlotEditForm
                    item={{}}
                    cancelEdit={() => setShowCreateSlot(false)}
                    refresh={(createdSlot) => {
                        setShowCreateSlot(false);
                        if (createdSlot) {
                            onSlotSelected([createdSlot]);
                        }
                    }}
                />
            )}
        </>
    );
}

export default ProgramScheduleSlotEditForm